<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-row no-gutters>
        <v-col cols="10">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="showNeueStriche = true" v-on="on"><v-icon>add</v-icon></v-btn>
            </template>
            <span>Erstellen</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="(showRechnungenGenerieren = true) && (fortschritt = 0) && (e1 = 1)"
                ><v-icon>send</v-icon></v-btn
              >
            </template>
            <span>Rechnungen erstellen</span>
          </v-tooltip>
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn disabled icon v-on="on" @click.stop='showFilter = !showFilter'><v-icon>filter_list</v-icon></v-btn> 
            </template>
            <span>Einträge filtern (Klappt nicht)</span>
          </v-tooltip> -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="showStatistik = true"><v-icon>insights</v-icon></v-btn>
            </template>
            <span>Statistik</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2" class="text-right">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Suchen"
            single-line
            solo
            flat
            hide-details
            clearable
            clear-icon="close"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-divider></v-divider>

    <v-dialog
      v-if="showStatistik"
      v-model="showStatistik"
      width="70%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card class="pa-0 ma-0">
        <v-card-title>
          <div>Statistik</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="showStatistik = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="ma-0 pa-0">
          <v-row no-gutters>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="3" class="pa-1">
                  <v-card class="text-center" height="100%" outlined>
                    <v-card-title class="justify-center">{{ statistik.anzahlStriche }}</v-card-title>
                    <v-card-subtitle>Striche</v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="3" class="pa-1">
                  <v-card class="text-center" height="100%" outlined>
                    <v-card-title class="justify-center">{{ statistik.anzahlEKP }}</v-card-title>
                    <v-card-subtitle>EKP</v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="3" class="pa-1">
                  <v-card class="text-center" height="100%" outlined>
                    <v-card-title class="justify-center">{{ statistik.anzahlPauschal }}</v-card-title>
                    <v-card-subtitle>Pauschal</v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="3" class="pa-1">
                  <v-card class="text-center" height="100%" outlined>
                    <v-card-title class="justify-center">{{ statistik.anzahlRechnungen }}</v-card-title>
                    <v-card-subtitle>Rechnungen</v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-1">
                  <v-card class="text-center pt-1" height="100%" outlined>
                    <v-progress-circular
                      :rotate="270"
                      :size="80"
                      :width="5"
                      :value="(statistik.umsatzStriche / statistik.umsatzGesamt) * 100"
                      color="primary"
                    >
                      {{ statistik.umsatzStriche | money }}
                    </v-progress-circular>
                    <v-card-text class="pa-1"
                      >Umsatz <br />
                      Striche</v-card-text
                    >
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-1">
                  <v-card class="text-center pt-1" height="100%" outlined>
                    <v-progress-circular
                      :rotate="270"
                      :size="80"
                      :width="5"
                      :value="(statistik.umsatzEKP / statistik.umsatzGesamt) * 100"
                      color="primary"
                    >
                      {{ statistik.umsatzEKP | money }}
                    </v-progress-circular>
                    <v-card-text class="pa-1"
                      >Umsatz <br />
                      EKP</v-card-text
                    >
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-1">
                  <v-card class="text-center pt-1" height="100%" outlined>
                    <v-progress-circular
                      :rotate="270"
                      :size="80"
                      :width="5"
                      :value="(statistik.umsatzPauschal / statistik.umsatzGesamt) * 100"
                      color="primary"
                    >
                      {{ statistik.umsatzPauschal | money }}
                    </v-progress-circular>
                    <v-card-text class="pa-1">Umsatz<br />Pauschal</v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" class="pa-1">
                  <v-card class="text-center pt-1" height="100%" outlined>
                    <v-progress-circular
                      :rotate="270"
                      :size="80"
                      :width="5"
                      :value="(statistik.umsatzGesamt / statistik.umsatzGesamt) * 100"
                      color="primary"
                    >
                      {{ statistik.umsatzGesamt | money }}
                    </v-progress-circular>
                    <v-card-text class="pa-1">Umsatz Gesamt</v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" class="pa-1">
              <v-card height="100%" outlined>
                <v-simple-table dense fixed-header height="378px">
                  <thead>
                    <tr>
                      <th></th>
                      <th class="text-left">Bbr</th>
                      <th class="text-center">Striche</th>
                      <th class="text-center">EKP</th>
                      <th class="text-center">Pauschal</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in statistik.bestenliste" :key="index">
                      <td class="text-center">{{ index + 1 }}.</td>
                      <td>{{ $filters.user(item.id, bbrbbr) }}</td>
                      <td class="text-center">{{ item.striche }}</td>
                      <td class="text-right">{{ item.ekp | money }}</td>
                      <td class="text-right">{{ item.pauschal | money }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showStatistik = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="showNeueStriche"
      v-model="showNeueStriche"
      width="80%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card class="pa-0 ma-0">
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
        <v-card-title>
          <div>Neue Striche erstellen</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="showNeueStriche = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="ma-0 pa-0">
          <stricheNeu></stricheNeu>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showNeueStriche = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="showRechnungenGenerieren"
      v-model="showRechnungenGenerieren"
      width="60%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card class="pa-0 ma-0">
        <v-card-title>
          Rechnungen erstellen
          <v-spacer></v-spacer>
          <v-btn icon @click="(showRechnungenGenerieren = false) && ($vars.loading = false)"
            ><v-icon>close</v-icon></v-btn
          >
          <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0 ma-0">
          <v-stepper v-model="e1" flat outlined class="pa-0 ma-0">
            <v-stepper-header>
              <v-stepper-step :complete="e1 > 1" step="1"> Datum auswählen </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="e1 > 2" step="2"> Rechnungsdetails </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="3"> Zusammenfassung </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1" class="pa-1">
                <v-card height="500px" class="pa-1">
                  <v-row no-gutters>
                    <v-col cols="12"
                      ><v-checkbox
                        on-icon="check_box"
                        off-icon="check_box_outline_blank"
                        v-model="rechnung_alle"
                        label="Alle offenen Striche berechnen"
                      ></v-checkbox
                    ></v-col>
                    <v-col cols="6" class="pa-1">
                      <v-date-picker
                        full-width
                        v-if="!rechnung_alle"
                        prev-icon="keyboard_arrow_left"
                        next-icon="keyboard_arrow_right"
                        no-title
                        v-model="rechnung_von"
                        locale="de-de"
                      ></v-date-picker>
                    </v-col>
                    <v-col cols="6" class="pa-1">
                      <v-date-picker
                        full-width
                        v-if="!rechnung_alle"
                        prev-icon="keyboard_arrow_left"
                        next-icon="keyboard_arrow_right"
                        no-title
                        v-model="rechnung_bis"
                        locale="de-de"
                      ></v-date-picker>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2" class="pa-1">
                <v-card height="500px" class="pa-1">
                  <v-row class="ma-0">
                    <v-col cols="6" class="py-0 mt-2"
                      ><v-text-field outlined dense v-model="rechnung_titel" label="Rechnungstitel"></v-text-field
                    ></v-col>
                    <v-col cols="3" class="py-0 mt-2"
                      ><v-text-field outlined dense v-model="rechnung_datum" label="Rechnungsdatum"></v-text-field
                    ></v-col>
                    <v-col cols="3" class="py-0 mt-2"
                      ><v-text-field
                        outlined
                        dense
                        v-model="rechnung_zahlbar_bis"
                        label="Zahlbar bis"
                        messages="Standard: 10 Tage später"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="6" class="py-0"
                      ><v-textarea
                        outlined
                        dense
                        v-model="rechnung_freitext"
                        hint="<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>"
                        label="Rechnungstext"
                      ></v-textarea
                    ></v-col>
                    <v-col cols="6" class="py-0"
                      ><v-textarea
                        outlined
                        dense
                        v-model="rechnung_freitext_sepa"
                        hint="<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>"
                        label="Rechnungstext bei SEPA-Rechnung"
                      ></v-textarea
                    ></v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="3" class="pa-1">
                <v-card height="500px" class="pa-1">
                  <v-row no-gutters class="ma-0">
                    <v-col cols="12" class="pa-1">
                      <v-card outlined>
                        <v-card-title class="justify-center pt-1 pb-0 subtitle-2">Zahlbar bis</v-card-title>
                        <v-card-title class="justify-center pt-0 pb-1">{{
                          $filters.date(rechnung_zahlbar_bis, "DD.MM.YYYY")
                        }}</v-card-title>
                      </v-card>
                    </v-col>
                    <v-col cols="4" class="pa-1">
                      <v-card outlined>
                        <v-card-title class="justify-center pt-1 pb-0 subtitle-2">Rechnungen</v-card-title>
                        <v-card-title class="justify-center pt-0 pb-1">{{ rechnung_anzahl }}</v-card-title>
                      </v-card>
                    </v-col>
                    <v-col cols="4" class="pa-1">
                      <v-card outlined>
                        <v-card-title class="justify-center pt-1 pb-0 subtitle-2">Betrag</v-card-title>
                        <v-card-title class="justify-center pt-0 pb-1">{{ rechnung_summe | money }}</v-card-title>
                      </v-card>
                    </v-col>
                    <v-col cols="4" class="pa-1">
                      <v-card outlined>
                        <v-card-title class="justify-center pt-1 pb-0 subtitle-2">Davon per SEPA</v-card-title>
                        <v-card-title class="justify-center pt-0 pb-1">{{ rechnung_summe_sepa | money }}</v-card-title>
                      </v-card>
                    </v-col>
                    <v-col cols="4" class="pa-1">
                      <v-card outlined>
                        <v-card-title class="justify-center pt-1 pb-0 subtitle-2">Striche</v-card-title>
                        <v-card-title class="justify-center pt-0 pb-1">{{
                          rechnung_summe_striche | money
                        }}</v-card-title>
                      </v-card>
                    </v-col>
                    <v-col cols="4" class="pa-1">
                      <v-card outlined>
                        <v-card-title class="justify-center pt-1 pb-0 subtitle-2">EKP</v-card-title>
                        <v-card-title class="justify-center pt-0 pb-1">{{ rechnung_summe_ekp | money }}</v-card-title>
                      </v-card>
                    </v-col>
                    <v-col cols="4" class="pa-1">
                      <v-card outlined>
                        <v-card-title class="justify-center pt-1 pb-0 subtitle-2">Pauschal</v-card-title>
                        <v-card-title class="justify-center pt-0 pb-1">{{
                          rechnung_summe_pauschal | money
                        }}</v-card-title>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-divider class="my-1"></v-divider>
                  <v-row no-gutters v-if="rechnungen.length > 0">
                    <v-col cols="12" class="pa-1">
                      <v-card outlined>
                        <v-card-title class="py-1">
                          <v-spacer></v-spacer>
                          <v-btn icon :disabled="index < 1" @click="index -= 1"
                            ><v-icon>keyboard_arrow_left</v-icon></v-btn
                          >
                          <div class="text-center subtitle-2">Rechnung {{ index + 1 }} von {{ rechnungen.length }}</div>
                          <v-btn icon :disabled="index > rechnungen.length - 2" @click="index += 1"
                            ><v-icon>keyboard_arrow_right</v-icon></v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-title>
                        <div class="text-center subtitle-2">
                          {{ $filters.user(rechnungen[index].bbrID, bbrbbr) }}
                        </div>
                        <v-simple-table dense fixed-header height="150">
                          <thead>
                            <tr>
                              <th width="20px" class="text-left"></th>
                              <th class="text-left">Was</th>
                              <th class="text-right">Betrag</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in rechnungen[index].positionen" :key="index">
                              <td width="20px">{{ index + 1 }}.</td>
                              <td>{{ item.was }}</td>
                              <td class="text-right">{{ item.betrag | money }}</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="4" class="pa-1">
                <v-card height="500px" class="pa-1">
                  <v-card-title class="justify-center"> Rechnungen werden erstellt </v-card-title>
                  <v-progress-linear
                    :color="fortschritt === 100 ? 'green' : 'blue'"
                    :value="fortschritt"
                    height="32"
                    rounded
                  >
                    {{ fortschritt.toFixed(0) }} %
                  </v-progress-linear>
                  <v-progress-linear
                    v-if="fortschritt < 100"
                    class="mt-n1"
                    color="blue"
                    height="4"
                    indeterminate
                    rounded
                  >
                  </v-progress-linear>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="e1 < 4" text @click.stop="(showRechnungenGenerieren = false) && (loading = false)"
            >Abbrechen</v-btn
          >
          <v-spacer></v-spacer>
          <div v-if="e1 === 1" class="text-right">
            <v-btn color="primary" @click="e1 = 2">Weiter</v-btn>
          </div>
          <div v-if="e1 === 2" class="text-right">
            <v-btn text @click="e1 = 1">Zurück</v-btn>
            <v-btn color="primary" @click="rechnungVorbereiten">Weiter</v-btn>
          </div>
          <div v-if="e1 === 3" class="text-right">
            <v-btn text @click="e1 = 2">Zurück</v-btn>
            <v-btn color="primary" :loading="loading" @click="rechnungErstellen">Erstellen</v-btn>
          </div>
          <div v-if="e1 === 4" class="text-right">
            <v-btn color="primary" :loading="fortschritt < 100" @click="showRechnungenGenerieren = false"
              >Schließen</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-navigation-drawer right app v-model="showFilter" :clipped='$vuetify.breakpoint.lgAndUp'>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            Striche Filtern
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <v-row>
        <v-col cols="12">
          <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :return-value.sync="filterVon" transition="slide-x-reverse-transition" offset-y max-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="filterVon"
                label="Von"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="filterVon" no-title scrollable locale="de-de">
              <div class="flex-grow-1"></div>
              <v-btn text color="primary" @click="menu1 = false">Abbrechen</v-btn>
              <v-btn text color="primary" @click="$refs.menu1.save(filterVon)">OK</v-btn>
            </v-date-picker>
          </v-menu>
          <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :return-value.sync="filterBis" transition="slide-x-reverse-transition" offset-y max-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="filterBis"
                label="Bis"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="filterBis" no-title scrollable locale="de-de">
              <div class="flex-grow-1"></div>
              <v-btn text color="primary" @click="menu2 = false">Abbrechen</v-btn>
              <v-btn text color="primary" @click="$refs.menu2.save(filterBis)">OK</v-btn>
            </v-date-picker>
          </v-menu>

          <v-text-field class="feld" name="" label="Bundesbruder" id="" v-model="filterBbr"></v-text-field>
          <v-select class="feld" :items="itemsStatus" label="Status" v-model="filterStatus"></v-select>
          <v-select class="feld" :items="itemsArt" label="Art" v-model="filterArt"></v-select>
        </v-col>
      </v-row>
      
    </v-navigation-drawer> -->

    <v-row class="ma-0">
      <v-col cols="12">
        <v-card outlined>
          <v-data-table
            dense
            :height="sideHeight"
            :headers="headers"
            :items="striche"
            :search="search"
            fixed-header
            :items-per-page="50"
            :footer-props="{
              'items-per-page-options': [50, 250, -1],
              'items-per-page-text': 'Striche pro Seite',
            }"
            no-data-text="Keine Striche vorhanden"
          >
            <template v-slot:header="{ item }">
              <tr class="hidden-sm-and-up">
                <th>Bundesbruder</th>
                <th>Datum</th>
                <th>Betrag</th>
              </tr>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ $filters.user(item.bbrID, bbrbbr) }}</td>
                <td>{{ $filters.date(item.date, "DD.MM.YYYY") }}</td>
                <td class="hidden-xs-only">{{ item.anzahl }}</td>
                <td>{{ (item.preis * item.anzahl) | money }}</td>
                <td class="hidden-xs-only">{{ item.grund }}</td>
                <td width="20px" class="pl-0 pr-0 hidden-xs-only">
                  <v-btn icon @click="deleteStrich(item.id)"><v-icon>delete</v-icon></v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:footer>
              <v-divider></v-divider>
              <v-row no-gutters>
                <v-spacer></v-spacer>
                <div class="subtitle-2 mt-2 mb-2 mr-2">Anzahl Striche: {{ anzahl }} - Summe: {{ summe | money }}</div>
              </v-row>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        filterVon: new Date().toISOString().substr(0, 10),
        menu1: false,
        filterBis: new Date().toISOString().substr(0, 10),
        menu2: false,
        filterBbr: "",
        filterStatus: "",
        filterArt: "",
        search: "",
        showStatistik: false,
        showFilter: false,
        itemsArt: ["Alle", "Striche", "EKP", "Pauschal"],
        itemsStatus: ["Alle", "Berechnet", "Nicht Berechnet"],
        showRechnungenGenerieren: false,
        e1: 1,
        headers: [
          { text: "Name", value: "bbr" },
          { text: "Datum", value: "date" },
          { text: "Anzahl", value: "anzahl" },
          { text: "Preis", value: "preis" },
          { text: "Was", value: "grund" },
          { text: "", value: "", sortable: false },
        ],
        rechnung_alle: true,
        rechnung_von: new Date().toISOString().substr(0, 10),
        rechnung_bis: new Date().toISOString().substr(0, 10),
        rechnung_titel: "Rechnung",
        rechnung_datum: new Date().toISOString().substr(0, 10),
        rechnung_zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 10)).toISOString().substr(0, 10),
        rechnung_freitext:
          "<<Briefanrede>> <<Nachname>>, \n\nhiermit bitte ich Dich die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ bis zum <<Zahlbar_bis>> zu überweisen. \n \nMit bundesbrüderlichen Grüßen \nThomas Wieczorek \nBierwart",
        rechnung_freitext_sepa:
          "<<Briefanrede>> <<Nachname>>, \n\nhiermit informiere ich Dich, dass die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ am <<Zahlbar_bis>> von Deinem Konto abgebucht wird. \n \nMit bundesbrüderlichen Grüßen \nThomas Wieczorek \nBierwart",
        rechnung_positionen: [],
        rechnung_anzahl: "",
        rechnung_summe: 0,
        rechnung_summe_sepa: 0,
        rechnung_summe_striche: 0,
        rechnung_summe_ekp: 0,
        rechnung_summe_pauschal: 0,
        rechnungStriche: [],
        rechnungen: [],
        rechnungsnummer: "",
        fortschritt: 0,
        summe: 0,
        loading: false,
        index: 0,
        anzahl: 0,
        showNeueStriche: false,
        options: {
          chart: {
            toolbar: {
              tools: {
                download: false,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false,
                customIcons: [],
              },
            },
            type: "area",
            stacked: false,
          },
          annotations: {
            xaxis: [],
          },
          dataLabels: { enabled: false },
          colors: ["#254fb3", "#EF5350", "#FFC107"],
          stroke: { width: 0 },
          tooltip: {
            y: {
              formatter: function (val, index) {
                return val.toFixed(0);
              },
            },
          },
          yaxis: {
            min: 0,
            tickAmount: 5,
            title: { text: undefined },
            labels: {
              formatter: function (val, index) {
                return val.toFixed(0);
              },
            },
          },
          xaxis: {
            title: { text: undefined },
            categories: [],
          },
          fill: {
            colors: ["#254fb3", "#EF5350", "#FFC107"],
            opacity: 1,
            type: "solid",
          },
          legend: { show: false },
        },
      };
    },
    computed: {
      statistik() {
        let statistik = {};
        statistik.anzahlStriche = 0;
        statistik.anzahlEKP = 0;
        statistik.anzahlPauschal = 0;
        // statistik.vonDatum
        // statistik.bisDatum
        statistik.umsatzStriche = 0;
        statistik.umsatzEKP = 0;
        statistik.umsatzPauschal = 0;
        statistik.umsatzGesamt = 0;
        statistik.bestenliste = {};
        statistik.anzahlRechnungen = 0;
        this.striche.forEach((strich) => {
          if (statistik.bestenliste[strich.bbrID] === undefined) {
            statistik.anzahlRechnungen++;
            statistik.bestenliste[strich.bbrID] = {
              id: strich.bbrID,
              striche: 0,
              ekp: 0,
              pauschal: 0,
            };
          }
          if (strich.art === "strich") {
            statistik.anzahlStriche = parseFloat(statistik.anzahlStriche) + parseFloat(strich.anzahl);
            statistik.umsatzStriche = parseFloat(statistik.umsatzStriche) + parseFloat(strich.preis * strich.anzahl);
            statistik.bestenliste[strich.bbrID].striche =
              statistik.bestenliste[strich.bbrID].striche + parseFloat(strich.anzahl);
          }
          if (strich.art === "ekp") {
            statistik.anzahlEKP = parseFloat(statistik.anzahlEKP) + parseFloat(strich.anzahl);
            statistik.umsatzEKP = parseFloat(statistik.umsatzEKP) + parseFloat(strich.preis * strich.anzahl);
            statistik.bestenliste[strich.bbrID].ekp =
              statistik.bestenliste[strich.bbrID].ekp + parseFloat(strich.preis * strich.anzahl);
          }
          if (strich.art === "pauschal") {
            statistik.anzahlPauschal = parseFloat(statistik.anzahlPauschal) + parseFloat(strich.anzahl);
            statistik.umsatzPauschal = parseFloat(statistik.umsatzPauschal) + parseFloat(strich.preis * strich.anzahl);
            statistik.bestenliste[strich.bbrID].pauschal =
              statistik.bestenliste[strich.bbrID].pauschal + parseFloat(strich.preis * strich.anzahl);
          }
        });
        statistik.umsatzGesamt = statistik.umsatzPauschal + statistik.umsatzStriche + statistik.umsatzEKP;
        var sortable = [];
        for (var item in statistik.bestenliste) {
          sortable.push(statistik.bestenliste[item]);
        }
        sortable.sort(function (a, b) {
          return b["striche"] - a["striche"];
        });
        statistik.bestenliste = sortable;
        // statistik.durchschnittStriche
        // statistik.durchschnittUmsatz
        return statistik;
      },
      striche() {
        if (this.$store.state.striche.loaded === false) {
          this.$store.dispatch("striche/loadStriche");
        }
        let striche = [];
        this.summe = 0;
        this.anzahl = 0;
        this.$store.getters["striche/striche"].forEach((strich) => {
          strich.grund = strich.grund === "Strich" ? "" : strich.grund;
          striche.push(strich);
          if (strich.art === "strich" || strich.art === "Strich") {
            this.summe = parseFloat(this.summe) + parseFloat(strich.preis * strich.anzahl);
            this.anzahl = parseFloat(this.anzahl) + parseFloat(strich.anzahl);
          } else {
            this.summe = parseFloat(this.summe) + parseFloat(strich.preis);
          }
        });
        this.$vars.loading = false;
        return striche;
      },
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      series() {
        let striche = this.striche;
        let minDatum = new Date(8640000000000000).toLocaleString(["de-de"], {
          month: "short",
          day: "2-digit",
          year: "numeric",
        });
        let maxDatum = new Date(0).toLocaleString(["de-de"], { month: "short", day: "2-digit", year: "numeric" });
        var result = [];
        let series = [
          {
            data: [],
            name: "Striche",
          },
        ];
        striche.forEach((strich) => {
          let datum = new Date(strich.date.seconds * 1000).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          });
          if (datum < minDatum) {
            minDatum = datum;
          }
          if (datum > maxDatum) {
            maxDatum = datum;
          }
        });
        for (let dt = new Date(minDatum); dt <= new Date(maxDatum); dt.setDate(dt.getDate() + 1)) {
          let datum = new Date(dt).toLocaleString(["de-de"], { month: "short", day: "2-digit", year: "numeric" });
          result.push({ datum, anzahl: 0 });
        }
        striche.forEach((strich) => {
          let datum = new Date(strich.date.seconds * 1000).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          });
          if (strich.art === "strich") {
            let index = result.map((object) => object.datum).indexOf(datum);
            result[index].anzahl += parseInt(strich.anzahl);
          }
        });
        let max = 0;
        result.forEach((item) => {
          if (item.anzahl > max) {
            max = item.anzahl;
          }
          series[0].data.push(item.anzahl);
          let datum = new Date(item.datum).toLocaleString(["de-de"], { month: "short", day: "2-digit" });
          this.options.xaxis.categories.push(datum);
        });
        this.options.yaxis.max =
          Math.ceil(max / Math.pow(10, max.toString().length - 1)) * Math.pow(10, max.toString().length - 1);
        return series;
      },
      sideHeight() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "calc(100vh - 289px)";
          case "sm":
            return "calc(100vh - 289px)";
          case "md":
            return "calc(100vh - 289px)";
          case "lg":
            return "calc(100vh - 289px)";
          case "xl":
            return "calc(100vh - 289px)";
        }
      },
    },
    methods: {
      rechnungVorbereiten() {
        this.$vars.loading = !this.$vars.loading;
        this.rechnung_anzahl = "";
        this.rechnung_positionen = [];
        this.rechnung_summe = 0;
        this.rechnung_summe_sepa = 0;
        this.rechnung_summe_striche = 0;
        this.rechnung_summe_ekp = 0;
        this.rechnung_summe_pauschal = 0;
        this.rechnungStriche = [];
        this.rechnungen = [];
        if (this.rechnung_alle) {
          this.rechnungStriche = this.striche;
        } else {
          this.rechnungStriche = [];
          this.striche.forEach((strich) => {
            let date = new Date(new Date(strich.date.seconds * 1000).setHours(2)).toISOString().substr(0, 10);
            if (this.rechnung_von <= date && date <= this.rechnung_bis) {
              this.rechnungStriche.push(strich);
            }
          });
        }
        // Zusammenrechnen der Striche
        let bbrbbr = [];
        this.rechnungStriche.forEach((strich) => {
          if (bbrbbr.indexOf(strich.bbrID) === -1) {
            bbrbbr.push(strich.bbrID);
          }
        });
        const result = {};
        let key = "bbrID";
        this.rechnungStriche.forEach((item) => {
          if (!result[item[key]]) {
            result[item[key]] = [];
          }
          result[item[key]].push({
            id: item[key],
            item,
          });
        });
        bbrbbr.forEach((bbr) => {
          let sepaInfo = false;
          let user = this.$store.getters["bbrbbr/bbr"](bbr);
          console.log(bbr);
          if (user.sepa) {
            if (
              user.sepa["Bierkasse"] &&
              user.iban !== "" &&
              user.bic !== "" &&
              user.kontoinhaber !== "" &&
              user.mandatsreferenz !== ""
            ) {
              sepaInfo = true;
            }
          }
          let rechnungPositionen = [];
          let posStriche = [];
          let posEkp = [];
          let posPauschal = [];
          let sumStriche = 0;
          let sumEkp = 0;
          let sumPauschal = 0;
          for (let i = 0; i < result[bbr].length; i++) {
            switch (result[bbr][i].item.art) {
              case "strich":
                sumStriche =
                  parseFloat(sumStriche) + parseFloat(result[bbr][i].item.preis * result[bbr][i].item.anzahl);
                this.rechnung_summe_striche =
                  parseFloat(this.rechnung_summe_striche) +
                  parseFloat(result[bbr][i].item.preis * result[bbr][i].item.anzahl);
                if (sepaInfo) {
                  this.rechnung_summe_sepa =
                    this.rechnung_summe_sepa + parseFloat(result[bbr][i].item.preis * result[bbr][i].item.anzahl);
                }
                posStriche.push({
                  id: result[bbr][i].item.id,
                  datum: result[bbr][i].item.date,
                  preis: result[bbr][i].item.preis * result[bbr][i].item.anzahl,
                  anzahl: result[bbr][i].item.anzahl,
                });
                break;
              case "ekp":
                sumEkp = parseFloat(sumEkp) + parseFloat(result[bbr][i].item.preis);
                this.rechnung_summe_ekp = parseFloat(this.rechnung_summe_ekp) + parseFloat(result[bbr][i].item.preis);
                if (sepaInfo) {
                  this.rechnung_summe_sepa = this.rechnung_summe_sepa + parseFloat(result[bbr][i].item.preis);
                }
                posEkp.push({
                  id: result[bbr][i].item.id,
                  datum: result[bbr][i].item.date,
                  preis: result[bbr][i].item.preis,
                  was: result[bbr][i].item.grund,
                });
                break;
              case "pauschal":
                sumPauschal = parseFloat(sumPauschal) + parseFloat(result[bbr][i].item.preis);
                this.rechnung_summe_pauschal =
                  parseFloat(this.rechnung_summe_pauschal) + parseFloat(result[bbr][i].item.preis);
                if (sepaInfo) {
                  this.rechnung_summe_sepa = this.rechnung_summe_sepa + parseFloat(result[bbr][i].item.preis);
                }
                posPauschal.push({
                  id: result[bbr][i].item.id,
                  datum: result[bbr][i].item.date,
                  preis: result[bbr][i].item.preis,
                  was: result[bbr][i].item.grund,
                });
                break;
              default:
                console.log("Fehler");
            }
          }
          let a = "0000" + this.rechnungsnummer[2]++;
          let b = a.substr(a.length - 4, 4);
          let rechnungsnummer = this.rechnungsnummer[0] + "-" + b;
          if (sumStriche !== 0) {
            rechnungPositionen.push({
              was: "Striche",
              betrag: sumStriche.toFixed(2),
              positionen: posStriche,
            });
          }
          if (sumEkp !== 0) {
            rechnungPositionen.push({
              was: "EKP",
              betrag: sumEkp.toFixed(2),
              positionen: posEkp,
            });
          }
          if (sumPauschal !== 0) {
            rechnungPositionen.push({
              was: "Pauschal",
              betrag: sumPauschal.toFixed(2),
              positionen: posPauschal,
            });
          }
          if (sepaInfo) {
            this.rechnungen.push({
              bbr:
                this.$store.getters["bbrbbr/bbr"](bbr).nachname + ", " + this.$store.getters["bbrbbr/bbr"](bbr).vorname,
              bbrID: bbr,
              rechnung_art: "SEPA",
              gezahlt_Datum: this.rechnung_zahlbar_bis,
              rechnung_titel: this.rechnung_titel,
              rechnung_datum: this.rechnung_datum,
              rechnung_zahlbar_bis: this.rechnung_zahlbar_bis,
              rechnung_freitext: this.rechnung_freitext_sepa,
              positionen: rechnungPositionen,
              status: "Entwurf SEPA",
              rechnungsnummer,
            });
          } else {
            this.rechnungen.push({
              bbr:
                this.$store.getters["bbrbbr/bbr"](bbr).nachname + ", " + this.$store.getters["bbrbbr/bbr"](bbr).vorname,
              bbrID: bbr,
              rechnung_art: "Überweisung",
              rechnung_titel: this.rechnung_titel,
              rechnung_datum: this.rechnung_datum,
              rechnung_zahlbar_bis: this.rechnung_zahlbar_bis,
              rechnung_freitext: this.rechnung_freitext,
              positionen: rechnungPositionen,
              status: "Entwurf",
              rechnungsnummer,
            });
          }
        });
        this.rechnung_anzahl = this.rechnungen.length;
        this.rechnung_summe =
          parseFloat(this.rechnung_summe_striche) +
          parseFloat(this.rechnung_summe_ekp) +
          parseFloat(this.rechnung_summe_pauschal);
        this.$vars.loading = !this.$vars.loading;
        this.e1 = 3;
      },
      ersetzeText(text, rechnung) {
        let summe = 0;
        rechnung.positionen.forEach((position) => {
          summe = parseFloat(summe) + parseFloat(position.betrag);
        });
        // console.log(rechnung)
        let name = rechnung.bbr.split(", ");
        text = text.replace("<<Rechnungstitel>>", rechnung.rechnung_titel);
        text = text.replace(
          "<<Rechnungsdatum>>",
          new Date(rechnung.rechnung_datum).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          })
        );
        text = text.replace("<<Rechnungsnummer>>", rechnung.rechnungsnummer);
        text = text.replace("<<Briefanrede>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).briefanrede);
        text = text.replace("<<Vorname>>", name[1]);
        text = text.replace("<<Nachname>>", name[0]);
        text = text.replace("<<Rechnungsbetrag>>", summe.toFixed(2));
        text = text.replace(
          "<<Zahlbar_bis>>",
          new Date(rechnung.rechnung_zahlbar_bis).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          })
        );
        return text;
      },
      rechnungErstellen() {
        this.loading = true;
        this.e1 = 4;
        let fortschrittMax = this.rechnungen.length + this.rechnungStriche.length + 1;
        let fortschritt = 0;
        this.fortschritt = (fortschritt / fortschrittMax) * 100;
        this.rechnungen.forEach((rechnung) => {
          rechnung.rechnung_freitext = this.ersetzeText(rechnung.rechnung_freitext, rechnung);
          rechnung.rechnung_freitext_code = rechnung.rechnung_freitext.replace(/(?:\r\n|\r|\n)/g, "<br>");
          rechnung.kasse = "Bierkasse";
          // Rechnung erstellen
          this.$store.dispatch("rechnungen/createRechnung", rechnung);
          fortschritt++;
          this.fortschritt = (fortschritt / fortschrittMax) * 100;
        });
        // Alle Striche als berechnet markieren
        this.rechnungStriche.forEach((strich) => {
          let value = {
            id: strich.id,
            status: "berechnet",
          };
          this.$store.dispatch("striche/updateStrichData", value);
          fortschritt++;
          this.fortschritt = (fortschritt / fortschrittMax) * 100;
        });
        let rechnungsnummer = {
          rechnungsnummer: [this.rechnungsnummer[0], this.rechnungsnummer[1], this.rechnungsnummer[2]],
        };
        this.$firebase
          .firestore()
          .collection("vereine")
          .doc(this.$vars.verbindung)
          .collection("einstellungen")
          .doc("rechnungsnummer")
          .update(rechnungsnummer)
          .then(() => {
            this.loading = false;
            this.fortschritt = 100;
            // this.showRechnungenGenerieren = false
          })
          .catch((error) => {
            console.log(error);
          });
      },
      deleteStrich(value) {
        this.$store.dispatch("striche/deleteStrichData", value);
      },
    },
    beforeMount() {
      this.$vars.loading = false;
      this.$firebase
        .firestore()
        .collection("vereine")
        .doc(this.$vars.verbindung)
        .collection("einstellungen")
        .doc("rechnungsnummer")
        .get()
        .then((doc) => {
          if (!doc.exists) {
            console.log("Dokument existiert nicht");
            this.$vars.loading = false;
          } else {
            if (doc.data().rechnungsnummer) {
              this.rechnungsnummer = [
                doc.data().rechnungsnummer[0],
                doc.data().rechnungsnummer[1],
                doc.data().rechnungsnummer[2],
              ];
            }
            this.$vars.loading = false;
          }
        })
        .catch((err) => {
          console.log("Error getting document", err);
        });
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// bierwartStriche.vue?2dee1ca3